export const MODEL_CONFIG = {
  OPENAI: {
    logoPath: '/svgs/openai-logo.svg',
    'gpt-3.5-turbo': {
      label: 'gpt-3.5-turbo',
      supportsImages: true,
      webAccess: false,
      legacy: true,
    },
    'gpt-4-turbo': {
      label: 'gpt-4-turbo',
      supportsImages: true,
      webAccess: false,
      legacy: true,
    },
    'gpt-4-turbo-vision': {
      label: 'gpt-4-turbo-vision',
      supportsImages: true,
      webAccess: false,
      legacy: true,
    },
    'gpt-4o': {
      label: 'gpt-4o',
      supportsImages: true,
      webAccess: false,
      legacy: true,
    },
    'gpt-4o-mini': {
      label: 'gpt-4o-mini',
      isDefault: false,
      supportsImages: true,
      webAccess: false,
      legacy: true,
    },
    'gpt-4.1': {
      label: 'gpt-4.1',
      supportsImages: true,
      webAccess: false,
      legacy: true,
    },
    'gpt-4.1-mini': {
      label: 'gpt-4.1-mini',
      supportsImages: true,
      webAccess: false,
      legacy: true,
    },
    'gpt-4.1-nano': {
      label: 'gpt-4.1-nano',
      supportsImages: true,
      webAccess: false,
      legacy: true,
    },
    'gpt-5': {
      label: 'gpt-5',
      supportsImages: true,
      webAccess: false,
      legacy: false,
      supportsReasoningEffort: true,
    },
    'gpt-5-mini': {
      label: 'gpt-5-mini',
      supportsImages: true,
      webAccess: false,
      legacy: false,
      supportsReasoningEffort: true,
    },
    'gpt-5-nano': {
      label: 'gpt-5-nano',
      supportsImages: false,
      webAccess: false,
      legacy: false,
      supportsReasoningEffort: true,
    },
    'gpt-5.2': {
      isDefault: true,
      label: 'gpt-5.2',
      supportsImages: true,
      webAccess: false,
      legacy: false,
      supportsReasoningEffort: true,
    },
    'gpt-5.4': {
      label: 'gpt-5.4',
      supportsImages: true,
      webAccess: false,
      legacy: false,
      supportsReasoningEffort: true,
    },
    'gpt-5.5': {
      label: 'gpt-5.5',
      supportsImages: true,
      webAccess: false,
      legacy: false,
      supportsReasoningEffort: true,
    },
    o3: {
      label: 'o3',
      supportsImages: true,
      webAccess: false,
      legacy: false,
      supportsReasoningEffort: true,
    },
    'o3-mini': {
      label: 'o3-mini',
      supportsImages: false,
      webAccess: false,
      legacy: true,
    },
    'o4-mini': {
      label: 'o4-mini',
      supportsImages: true,
      webAccess: false,
      legacy: false,
      supportsReasoningEffort: true,
    },
    'o1-preview': {
      label: 'o1-preview',
      supportsImages: false,
      webAccess: false,
      legacy: true,
    },
    'gpt-4o-search-preview': {
      label: 'gpt-4o-search-preview',
      supportsImages: false,
      webAccess: true,
      legacy: true,
    },
    'gpt-4o-mini-search-preview': {
      label: 'gpt-4o-mini-search-preview',
      supportsImages: false,
      webAccess: true,
      legacy: true,
    },
  },
  ANTHROPIC: {
    logoPath: '/svgs/anthropic-logo.svg',
    'claude-3-5-haiku-20241022': {
      label: 'Claude 3.5 Haiku',
      supportsImages: true,
      webAccess: false,
      legacy: true,
    },
    'claude-3-5-sonnet-20241022': {
      label: 'Claude 3.5 Sonnet (2024-10-22)',
      supportsImages: true,
      webAccess: false,
      legacy: true,
    },
    'claude-3-7-sonnet-20250219': {
      label: 'Claude 3.7 Sonnet',
      supportsImages: true,
      webAccess: false,
      legacy: true,
      supportsReasoningEffort: true,
    },
    'claude-sonnet-4-20250514': {
      label: 'Claude Sonnet 4',
      supportsImages: true,
      webAccess: false,
      legacy: false,
      supportsReasoningEffort: true,
    },
    'claude-sonnet-4-5-20250929': {
      label: 'Claude Sonnet 4.5',
      supportsImages: true,
      webAccess: false,
      legacy: true,
      supportsReasoningEffort: true,
    },
    'claude-haiku-4-5-20251001': {
      label: 'Claude Haiku 4.5',
      supportsImages: true,
      webAccess: false,
      legacy: false,
      supportsReasoningEffort: true,
    },
    'claude-opus-4-5-20251101': {
      label: 'Claude Opus 4.5',
      supportsImages: true,
      webAccess: false,
      legacy: true,
      supportsReasoningEffort: true,
    },
    'claude-sonnet-4-6': {
      label: 'Claude Sonnet 4.6',
      supportsImages: true,
      webAccess: false,
      legacy: false,
      supportsReasoningEffort: true,
    },
    'claude-opus-4-6': {
      label: 'Claude Opus 4.6',
      supportsImages: true,
      webAccess: false,
      legacy: false,
      supportsReasoningEffort: true,
    },
    'claude-opus-4-7': {
      label: 'Claude Opus 4.7',
      supportsImages: true,
      webAccess: false,
      legacy: false,
      supportsReasoningEffort: true,
    },
  },
  GOOGLE: {
    logoPath: '/svgs/google-ai-studio-logo.svg',
    'gemini-2.0-flash': {
      label: 'gemini-2.0-flash',
      supportsImages: false,
      webAccess: false,
      legacy: false,
    },
    'gemini-2.5-flash': {
      label: 'gemini-2.5-flash',
      supportsImages: true,
      webAccess: false,
      legacy: false,
      supportsReasoningEffort: true,
    },
    'gemini-2.5-pro': {
      label: 'gemini-2.5-pro',
      supportsImages: true,
      webAccess: false,
      legacy: false,
      supportsReasoningEffort: true,
    },
    'gemini-3.1-pro-preview': {
      label: 'gemini-3.1-pro-preview',
      supportsImages: true,
      webAccess: false,
      legacy: false,
      supportsReasoningEffort: true,
    },
    'gemini-3.5-flash': {
      label: 'gemini-3.5-flash',
      supportsImages: true,
      webAccess: false,
      legacy: false,
      supportsReasoningEffort: true,
    },
  },
};

export const AVAILABLE_MODELS = Object.values(MODEL_CONFIG).flatMap(models => Object.keys(models));

export const DEFAULT_MODEL =
  Object.entries(MODEL_CONFIG)
    .flatMap(([_, models]) => Object.entries(models))
    .find(([_, config]) => config.isDefault)?.[0] || 'gpt-5.2';

export const REASONING_EFFORT_DEFAULT = 'MEDIUM';
export const REASONING_EFFORT_OPTIONS = [
  { value: 'LOW', label: 'Low' },
  { value: 'MEDIUM', label: 'Medium' },
  { value: 'HIGH', label: 'High' },
];

export const getModelConfig = modelId => {
  for (const [, models] of Object.entries(MODEL_CONFIG)) {
    const config = models[modelId];
    if (config && typeof config === 'object') return config;
  }
  return null;
};

export const supportsReasoningEffort = modelId =>
  getModelConfig(modelId)?.supportsReasoningEffort === true;
